<h4 class="title">License List</h4>
<div class="row">
    <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div>
    <div class="col-md-8 text-right">
        <button type="button" class="btn btn-primary mr-0" (click)="client_form()" >Add</button> 
    </div>
</div>
<div class="doc-table">

<div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
  
    <ng-template pTemplate="header">
        <tr class="thhead">
            <th class="th-1">
                S.No
            </th>
            <th>
                Client Name
            </th>
            <th>
                Number of License
            </th>
            <th>
                Admin user Name
            </th>
            <th>
                Admin user Email
            </th>
            <th>
                Admin user Phone
            </th>
            <th>
                Admin user Password
            </th>
            <!-- <th>Created by</th>
            <th>Modified by</th>
            <th>Created at</th>
            <th>Modified at</th> -->
            <th style="width: 110px;text-align:center">
                Action
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr class="tdrow">
            <td>{{i+1}}</td>
            <td>Test Name</td>
            <td>10</td>
            <td>User-1</td>
            <td>test@gmail.com</td>
            <td>98765410</td>
            <td>ASDFGHJLKIU</td>
            <!-- <td>
                User
            </td>
            <td>
                Admin
            </td>
            <td>
                16-09-2020
            </td>
            <td>
                17-09-2020
            </td> -->
            <td class="act">
                <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                <!-- <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="profile()" pTooltip="Profile"></i> -->
            </td>
        </tr>
    </ng-template>
 </p-table>  </div>

</div>